import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMl = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 450 300", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { fill: "#CE1126", width: 450, height: 300 }), /* @__PURE__ */ React.createElement("rect", { fill: "#FCD116", width: 300, height: 300 }), /* @__PURE__ */ React.createElement("rect", { fill: "#14B53A", width: 150, height: 300 }));
const ForwardRef = forwardRef(SvgMl);
const Memo = memo(ForwardRef);
export default Memo;
